import * as React from 'react';

import { Link } from 'libs/router';

import type { Breadcrumb } from 'types';

type Props = {
  items: Array<Breadcrumb>
};

class Breadcrumbs extends React.PureComponent<Props> {
  render(): React.ReactNode {
    const { items } = this.props;

    return (
      <section className="breadcrumbs">
        {
          items.map((item, index) => {
            const isNotLastItem = index < items.length - 1;

            return (
              <React.Fragment key={`breadcrumb-item-${item.label}-${index}`}>
                <div className="breadcrumbs__item">
                  {
                    isNotLastItem ?
                      <Link
                        to={item.link}
                        className="breadcrumbs__link"
                      >
                        {item.label}
                      </Link> :
                      <span className="breadcrumbs__item--selected">
                        {item.label}
                      </span>
                  }
                </div>
                {
                  isNotLastItem && (
                    <div className="breadcrumbs__divider">
                      &gt;
                    </div>
                  )
                }
              </React.Fragment>
            );
          })
        }
      </section>
    );
  }
}

export default Breadcrumbs;
